import { useState } from "react";
import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { BRAND_LOGOS } from "../../constants/siteData";

const halfway = Math.ceil(BRAND_LOGOS.length / 2);
const row1 = BRAND_LOGOS.slice(0, halfway);
const row2 = BRAND_LOGOS.slice(halfway);

const BrandTile = ({ brand, testId }) => {
  const [imgFailed, setImgFailed] = useState(false);

  return (
    <div className="brand-tile" data-testid={testId}>
      {!imgFailed ? (
        <img
          src={brand.url}
          alt={brand.name}
          loading="lazy"
          onError={() => setImgFailed(true)}
        />
      ) : (
        <span className="brand-tile-text">{brand.name}</span>
      )}
    </div>
  );
};

export const BrandTicker = () => {
  return (
    <section
      id="brands"
      className="relative bg-navy py-24 md:py-32 border-y hairline overflow-hidden"
      data-testid="brand-ticker-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-12 md:mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="max-w-2xl"
          >
            <p className="kicker mb-5">Our Portfolio</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tighter text-cream">
              50+ world-class brands, <span className="text-coral">one</span> distribution partner.
            </h2>
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-white/60 md:text-right md:max-w-xs"
          >
            From household staples to premium personal care, our shelves are stocked with the brands your customers already ask for by name.
          </motion.p>
        </div>
      </div>

      <div className="marquee-mask">
        <Marquee gradient={false} speed={45} pauseOnHover className="py-3">
          {row1.map((b, i) => (
            <BrandTile key={`r1-${i}`} brand={b} testId={`brand-tile-${b.name}`} />
          ))}
        </Marquee>
        <Marquee gradient={false} speed={40} direction="right" pauseOnHover className="py-3 mt-4">
          {row2.map((b, i) => (
            <BrandTile key={`r2-${i}`} brand={b} testId={`brand-tile-r2-${b.name}`} />
          ))}
        </Marquee>
      </div>

      <div className="max-w-[1440px] mx-auto px-6 md:px-10 mt-14 text-center">
        <p className="text-sm text-white/40 tracking-wide">
          We offer many more brands. <a href="#contact" className="text-coral hover:underline" data-testid="brands-contact-link">Contact us for the full catalogue →</a>
        </p>
      </div>
    </section>
  );
};
